var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95703 8.63477C3.95703 8.08248 4.40475 7.63477 4.95703 7.63477H12.4885C13.0408 7.63477 13.4885 8.08248 13.4885 8.63477V16.1663C13.4885 16.7186 13.0408 17.1663 12.4885 17.1663H4.95703C4.40475 17.1663 3.95703 16.7186 3.95703 16.1663V8.63477ZM5.6237 9.30143V15.4996H11.8219V9.30143H5.6237Z",
    fill: "#1A81C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03711 3.56641H16.5686C17.1209 3.56641 17.5686 4.01412 17.5686 4.56641V12.0979C17.5686 12.6502 17.1209 13.0979 16.5686 13.0979H13.4836V11.4312H15.9019V5.23307H9.70378V7.65087H8.03711V4.56641C8.03711 4.01412 8.48483 3.56641 9.03711 3.56641Z",
    fill: "#1A81C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fdca01051e22a114b1d751bf800a39ca.svg";
export { ForwardRef as ReactComponent };